import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RackDataService } from '../../data-services/rack.service';
import { LazyLoadEvent } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-rack-list',
  templateUrl: './rack.list.html',
  providers: [DialogService, MessageService],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0.5 }),
            animate('0.5s ease-out',
              style({ height: '*', opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: '*', opacity: 1 }),
            animate('0.5s ease-in',
              style({ height: 0, opacity: 0.5 }))
          ]
        )
      ]
    )
  ],
  imports: [Toast, CommonModule, TableModule, RouterModule]
})
export class RackListComponent implements OnInit {

  barcode = "";
  barcodeReading = false;

  constructor(private rackService: RackDataService,
    public dialogService: DialogService) {
  }

  racks;
  totalRecords: number;
  cols: any[];
  loading: boolean;

  ngOnInit() {
    this.cols = [
      { field: 'SerialNumber', header: 'Serial' },
      { field: 'RackTypeCode', header: 'Rack Type Code' },
      { field: 'RackTypeName', header: 'Rack Type' },
      { field: 'DepartmentId', header: 'Department ID' },
      { field: 'DepartmentName', header: 'Department' },
      { field: 'SampleCount', header: 'Samples' },
      { field: 'IsRackFull', header: 'Is Full' },
    ];
    this.loading = true;
  }

  searchTerm: string = "";
  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      reqlist.filterGlobal(event.target.value, 'contains');
      this.searchTerm = event.target.value;
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadRacksLazy(event: LazyLoadEvent) {
    this.loading = true;
    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.rackService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.racks = data.rows;
      event.filters.global = {};
      this.loading = false;
    });
  }

}
